import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import Header from '../../components/join/Header';
import Information from '../../components/join/Information';
import SearchBlock from '../../components/join/SearchBlock';
import SearchBox from '../../components/join/SearchBox';
import AddServicePopup from '../../components/popup/AddServicePopup';
import SEO from '../../components/SEO';
import { useRedirectUnauthorized } from '../../hooks/useRedirectUnauthenticated';

const JoinPro = () => {
    useRedirectUnauthorized({ allowPros: false });
    const [search ,showSearch]= useState(false);
    const lang = useSelector((state) => state.settings.lang);
    return (
        <>
            {
                search?
                    <>
                        <SearchBox func={(e)=>showSearch(e)}/>

                    </> :
                    <>
                        <SEO title="Join as Pro" />
                        <Header func={(e)=>showSearch(e)} lang={lang} />
                        <Information lang={lang} />
                        <SearchBlock lang={lang} />
                        <AddServicePopup />
                    </>
            }
        </>
    );
};

export default JoinPro;
